import HBIcon from "../HBIcon";
import { Switch, Case, When } from "react-if";
import styles from "./index.module.less";
import imageUrl from "@/utils/imageUrl";
import { useCallback, useState, forwardRef, useRef, useMemo } from "react";
import classNames from "classnames";
import VipCheckbox from "../Vip/vipCheckbox/checkBox";
import { useMemoizedFn, useSetState } from "ahooks";
import { getBoardsListByIds } from "@/services";
import Image from "../Image";

const ICON_MAP = {
  time: <HBIcon type="ic_schedule2" />,
  search: <HBIcon type="ic_search" />,
};

// 渲染个数
const RENDER_COUNT = 30;
// item高度
const ITEM_HEIGHT = 50;

function BoardSelectBoardList({ dataSource, onSelect, multiple }, ref) {
  const [renderIndex, setRenderIndex] = useState(0);

  const onScroll = useCallback((evt) => {
    const scrollTop = evt.target.scrollTop;
    // 计算渲染起始位置
    const index = Math.floor((scrollTop - 10 * ITEM_HEIGHT) / ITEM_HEIGHT);
    setRenderIndex(index < 0 ? 0 : index);
  }, []);

  // 优化：先获取不带封面的画板，当真实需要渲染时再请求画板展示
  // 带封面画板
  const [coverBoards, setCoverBoards] = useSetState({});
  // 更新封面画板
  const updateRef = useRef({
    timer: null,
    ids: new Set(),
  });

  const updateCovers = useMemoizedFn((id) => {
    updateRef.current.ids.add(id);
    if (updateRef.current?.timer) {
      return;
    }

    updateRef.current.timer = setTimeout(async () => {
      const ids = [...updateRef.current?.ids];
      updateRef.current.ids.clear();
      const { boards, err } = await getBoardsListByIds(ids, 1);
      if (err) {
        return;
      }

      const boardsMap = {};
      boards.forEach((board) => {
        boardsMap[board?.board_id] = board;
      });

      setCoverBoards(boardsMap);

      updateRef.current.timer = null;
    }, 0);
  });

  const getBoardCover = useMemoizedFn((board) => {
    const boardId = board.board_id;
    if (coverBoards[boardId]) {
      return (
        coverBoards[boardId]?.cover?.file ||
        (coverBoards[boardId]?.pins || [])[0]?.file
      );
    }

    updateCovers(boardId);
    return null;
  });

  const renderItem = useMemoizedFn((board) => {
    const coverFile = getBoardCover(board);

    return (
      <div
        className={classNames(
          { [styles.disabled]: board.disabled },
          styles.item
        )}
        key={board?.board_id}
        onClick={() =>
          !board.disabled && onSelect(coverBoards[board.board_id] || board)
        }
      >
        <Switch>
          <Case condition={board?._icon}>
            <div className={styles.icon}>
              {ICON_MAP[board?._icon] || board?._icon}
            </div>
          </Case>
          <Case condition={!board}>
            <div className={styles.icon}>{ICON_MAP.time}</div>
          </Case>
        </Switch>
        <div className={styles.content}>
          <div className={styles.left}>
            {multiple && (
              <VipCheckbox checked={board.checked} disabled={board.disabled} />
            )}
            <div className={styles.img}>
              {coverBoards[board.board_id] ? (
                coverFile ? (
                  <Image
                    src={imageUrl(coverFile, { width: 32 })}
                    alt={board?.title}
                  />
                ) : (
                  <div className={styles.cover}>
                    <HBIcon type="ic_logo" />
                  </div>
                )
              ) : (
                <div className={styles.block}></div>
              )}
            </div>
            <div className={styles.name}>{board?.title}</div>
            <When
              condition={
                board && board?.is_private !== 0 && board?.is_private !== 1
              }
            >
              <HBIcon
                type="ic_lock"
                className={styles.private}
                title="私有画板"
              />
            </When>
            <When condition={board && board?.extra?.is_creation}>
              <HBIcon
                type="copyright"
                className={styles.copyright}
                title="原创画板"
              />
            </When>
          </div>

          {board.disableText ? (
            <div className={styles.right}>{board.disableText}</div>
          ) : (
            <When condition={board}>
              <div className={styles.right}>
                <span>{board?.pin_count}</span>
              </div>
            </When>
          )}
        </div>
      </div>
    );
  });

  const items = useMemo(() => {
    const start = renderIndex;
    const end = start + RENDER_COUNT;

    const items = [
      <div key={"before"} style={{ height: start * ITEM_HEIGHT }}></div>,
    ];
    for (let i = start; i < end; i++) {
      if (dataSource[i]) {
        items.push(renderItem(dataSource[i]));
      }
    }
    const bottomHeight =
      dataSource.length > end ? (dataSource.length - end) * ITEM_HEIGHT : 0;
    items.push(<div key={"after"} style={{ height: bottomHeight }}></div>);
    return items;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSource, renderItem, renderIndex, coverBoards]);

  return (
    <div
      className={classNames(styles.menu, { [styles.multiple]: multiple })}
      ref={ref}
      onScroll={onScroll}
    >
      {items}
    </div>
  );
}

export default forwardRef(BoardSelectBoardList);
